import {gql} from "@apollo/client";

export const VALIDATE_PICKUP_APPOINTMENTS_COOPERATION_WAREHOUSE_STATUS = gql`
    query ValidatePickupAppointmentsCooperationWarehouseStatus($ids: [Long!]!) {
        validatePickupAppointmentsCooperationWarehouseStatus(ids: $ids) {
            success
            message
        }
    }
`;

export interface ValidateResult {
    success: boolean;
    message: string;
}

export interface ValidatePickupAppointmentsCooperationWarehouseStatusResponse {
    validatePickupAppointmentsCooperationWarehouseStatus: ValidateResult;
} 